import axios from 'axios'
import { mapNoticeItem, mapCourseItem } from 'utils/notices';

export const getAnnounces = function(bizLineId) {
    return axios.get('/trip-notify/acc/announces/special', {
        params: {
            bizLineId: bizLineId,
            servicePlatform: 1
        }
    }).then((respone) => {
        let data = respone && respone.data;
        if (data.noticeAnnPublishList) {
            data.notices = data.noticeAnnPublishList.map((noticeItem) => {
                return mapNoticeItem(noticeItem);
            });
        }
        if (data.ruleAnnPublishList) {
            data.rules = data.ruleAnnPublishList.map((ruleItem) => {
                return mapNoticeItem(ruleItem);
            });
        }
        if (data.meidaAnnPublishList) {
            data.courses = data.meidaAnnPublishList.map((courseItem) => {
                return mapCourseItem(courseItem);
            })
        }
        if (data.stripeDecorateList) {
            data.bannerTexts = data.stripeDecorateList.map((stripItem) => {
                return {
                    id: stripItem.announceId,
                    text: stripItem.decorateContent
                };
            });
        }
        if (data.bannerDecorateList) {
            data.bannerImages = data.bannerDecorateList.map((imgItem) => {
                return {
                    id: imgItem.announceId,
                    src: imgItem.decorateContent
                }
            });
        }
        if (data.rightDialogDecorateList) {
            data.topNotices = data.rightDialogDecorateList.map((dialogItem) => {
                return {
                    title: dialogItem.decorateTitle,
                    content: dialogItem.decorateContent,
                    id: dialogItem.announceId
                }
            });
        }
        return data;
    });
}


// WEBPACK FOOTER //
// ./src/api/nshared.js